import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // Match the persisted cache maxAge so restored queries aren't GC'd early;
      // stale data still triggers a background refetch (stale-while-revalidate).
      gcTime: 24 * 60 * 60_000,
      // The conversation list is kept fresh by the SSE stream, and each list
      // fetch mints fresh signed thumbnail URLs — refetching on focus would
      // re-pull every (large, signed) thumbnail for no benefit.
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})
